import { render, staticRenderFns } from "./lkuAdv.1.vue?vue&type=template&id=4dc68cfb"
import script from "./lkuAdv.1.vue?vue&type=script&lang=js"
export * from "./lkuAdv.1.vue?vue&type=script&lang=js"
import style0 from "./lkuAdv.1.vue?vue&type=style&index=0&id=4dc68cfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports